import React, { FC, useState } from 'react';

import CheckoutDonation from 'src/components/experienceCheckout/CheckoutDonation';
import {
  IChallengeCheckoutDonation,
  IChallengeResourceRender,
} from 'src/shared/models';

interface OwnProps extends IChallengeResourceRender {
  config: IChallengeCheckoutDonation;
}

const ChallengeCheckoutDonation: FC<OwnProps> = ({
  config,
  updateChallenge,
  updateUserPoints,
}) => {
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [selected, setSelected] = useState(false);

  const { isCompleted } = config;

  return (
    <>
      {!isCompleted && (
        <CheckoutDonation
          {...{
            config,
            loading,
            error,
            setLoading,
            selected,
            setSelected,
            setError,
            setShowModal,
            showModal,
            updateChallenge,
            updateUserPoints,
          }}
        />
      )}
    </>
  );
};

export default ChallengeCheckoutDonation;
